"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductionEnv = exports.ENVIRONMENT = void 0;
var getIsProduction = function () { return process.env.REACT_APP_ENVIRONMENT === 'master'; };
exports.ENVIRONMENT = getIsProduction() ? 'PRODUCTION' : 'PREPROD';
exports.isProductionEnv = getIsProduction();
//# sourceMappingURL=isProductionEnv.js.map